import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function VideoIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'Grey6', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { d: "M20.857 8.429l-5.583 3.988 5.583 3.988V8.429zM13.679 6.833H4.905c-.881 0-1.595.715-1.595 1.596v7.976c0 .88.714 1.595 1.595 1.595h8.774c.88 0 1.595-.714 1.595-1.595V8.429c0-.881-.714-1.596-1.595-1.596z", stroke: primaryFillColor, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}
//# sourceMappingURL=Video.js.map